import React, { useCallback } from 'react'
import { useDrawer } from 'ducks/drawers/hooks'
import { DRAWER_TYPE_SHOPIFY_CREATE_ORDER } from 'ducks/drawers/types'
import { Button } from 'util/ui'

const DuplicateOrderButton = ({ integration, order }) => {
  const { openDrawer } = useDrawer({
    type: DRAWER_TYPE_SHOPIFY_CREATE_ORDER,
  })

  const onOpen = useCallback(
    () => {
      openDrawer(order.customer.id, {
        additionalProps: {
          drawerIntegrationId: integration.id,
          order,
          isDuplicate: true,
        },
      })
    },
    [openDrawer, integration, order]
  )

  return (
    <Button basic onClick={onOpen}>
      Duplicate
    </Button>
  )
}

export default DuplicateOrderButton
